import {
  logger,
  hostCommunicationManager,
  cacheManager,
  cacheKeys,
  utils,
  settingsManager,
  scannerVersionManager,
  Environments,
  AOHSService,
  eventBus,
  globalEventsKeys,
} from '@web-3d-tool/shared-logic';
import { lazyLoadPreset, composePreset } from '@web-3d-tool/plugins';
import * as configValues from '@web-3d-tool/shared-logic/src/constants/configurationValues.constants';
import { loadLanguage } from '@web-3d-tool/localization';
import { eupInit, scannerInit23A, scannerInit23C, initModeAOHS } from './shell.middleware.logic';
import * as AT from '../../actionTypes';
import {
  loadPreset,
  setAppPreset,
  loadAOHSPreset,
  setPluginsPresetId,
  setIsAOHSMode,
  setSLContext,
} from './shell.actions';
import { loadModel, loadNiri } from '../renderer/renderer.actions';
import createMiddleware from './../../../middlewareHelper';
import { loadPlugins, clearPlugins, loadExtendZonesPlugins } from '../plugins/plugins.actions';

//******************************
const feature = AT.SHELL;
//******************************

export const goThroughOverride = ({ action, dispatch, getState }) => {};
export const middleware = async ({ action, dispatch, getState }) => {
  const { payload, type } = action;
  if (!payload || !type) {
    return;
  }
  switch (type) {
    case AT.APP_LOADED:
      {
        const state = getState();

        if (state) {
          logger
            .info('Initializing')
            .to(['host'])
            .data({ module: 'app shell', state: JSON.stringify(state.shell) })
            .end();
        }
        hostCommunicationManager.initHostCommunicationManager();

        const loadPresetProps = {
          pluginsPresetId: 'default',
        };

        const host = utils.getEnv();
        const isEupHost = host === Environments.EUP;
        const isScannerHost = host === Environments.SCANNER;
        const isAOHS = host === Environments.AOHS;

        if (isAOHS) {
          await initModeAOHS(dispatch, loadPreset, loadAOHSPreset, loadNiri, setSLContext, loadModel, setIsAOHSMode);
          const isAOHSInClearMode = AOHSService.isAOHSInClearMode();
          loadPresetProps.forceReloadPreset = true;
          if (isAOHSInClearMode) {
            loadPresetProps.pluginsPresetId = 'aohs_lean_mode_clear';
          } else {
            eventBus.raiseEvent(globalEventsKeys.RESET_AOHS_PLUGINS_AVAILABILITY);
          }
          await loadLanguage();
          dispatch(loadPreset({ ...loadPresetProps }));
        } else {
          switch (true) {
            case isEupHost:
              await eupInit(dispatch, setSLContext);
              break;
            case isScannerHost:
              const currentScannerVersion = scannerVersionManager.getScannerVersion();
              const { v23A, v23C } = scannerVersionManager.scannerAssetsVersions;
              if (currentScannerVersion === v23A) {
                await scannerInit23A();
              } else if (currentScannerVersion === v23C) {
                await scannerInit23C(dispatch, setSLContext);
              }
              break;
            default:
              // no default
              break;
          }

          await loadLanguage();
          dispatch([loadModel(), loadPreset({ ...loadPresetProps }), setIsAOHSMode({ isAOHS })]);
        }
      }
      break;

    case AT.LOAD_PRESET:
      {
        const presetId =
          getState().shell.presetId ||
          (utils.getIs360HubEnabled() ? '360' : settingsManager.getConfigValue(configValues.mode));
        const { forceReloadPreset, pluginsPresetId, initiatingPlugin } = payload;

        try {
          let preset;
          if (forceReloadPreset) {
            preset = await lazyLoadPreset(presetId);
          } else {
            preset = cacheManager.get(cacheKeys.PRESET) || (await lazyLoadPreset(presetId));
          }

          cacheManager.set(cacheKeys.PRESET, preset);
          const appPreset = await composePreset({ preset, pluginsPresetId });
          dispatch([
            clearPlugins({ initiatingPlugin }),
            setAppPreset({ appPreset }),
            loadPlugins({ initiatingPlugin }),
            setPluginsPresetId({ pluginsPresetId }),
          ]);
        } catch (err) {
          logger
            .error('LOAD_PRESET')
            .to(['host'])
            .data({ module: 'app shell', err: err })
            .end();
        }
      }
      break;

    case AT.ADD_PLUGINS:
      {
        const { presets } = payload;
        dispatch(loadExtendZonesPlugins({ presets }));
      }
      break;

    case AT.LOAD_AOHS_PRESET:
      {
        const { presetProps } = payload;
        dispatch([loadPreset({ ...presetProps })]);
      }
      break;

    default:
      //do nothing
      break;
  }
};

export default createMiddleware({
  feature,
  goThroughOverride,
})(middleware);
